var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardSeatDo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.678,
    height: 50,
    viewBox: "0 0 41.678 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 22"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 125",
    d: "M60.8 362.074h5.045v14.641H60.8z",
    transform: "translate(-54.86 -326.715)",
    style: {
      fill: "#657488"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 126",
    d: "M51.993 484.081h-5.976A1.084 1.084 0 0 1 44.934 483v-.832a1.084 1.084 0 0 1 1.084-1.084h5.976a1.084 1.084 0 0 1 1.084 1.084V483a1.084 1.084 0 0 1-1.084 1.084z",
    transform: "translate(-40.546 -434.101)",
    style: {
      fill: "#657488"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 127",
    d: "M314.32 362.074h5.046v14.641h-5.046z",
    transform: "translate(-283.625 -326.715)",
    style: {
      fill: "#657488"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 128",
    d: "M94.083 32.04H65.125V6.361A6.361 6.361 0 0 1 71.486 0h16.236a6.361 6.361 0 0 1 6.361 6.361z",
    transform: "translate(-58.765)",
    style: {
      fill: "#5cc060"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 129",
    d: "M248.924 0h-5.151a6.361 6.361 0 0 1 6.361 6.361V32.04h5.151V6.361A6.361 6.361 0 0 0 248.924 0z",
    transform: "translate(-219.967)",
    style: {
      fill: "#3eae60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 130",
    d: "M6.36 217.7v-14.452a1.76 1.76 0 0 0-1.76-1.76H1.76a1.76 1.76 0 0 0-1.76 1.76v8.092a6.36 6.36 0 0 0 6.36 6.36z",
    transform: "translate(0 -181.812)",
    style: {
      fill: "#3eae60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 131",
    d: "M361.656 217.7v-14.452a1.76 1.76 0 0 1 1.76-1.76h2.839a1.76 1.76 0 0 1 1.76 1.76v8.092a6.36 6.36 0 0 1-6.359 6.36z",
    transform: "translate(-326.338 -181.812)",
    style: {
      fill: "#5cc060"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 132",
    d: "M76.148 353.834H46.621a1.687 1.687 0 0 1-1.687-1.687v-4.088h32.9v4.088a1.687 1.687 0 0 1-1.686 1.687z",
    transform: "translate(-40.546 -314.068)",
    style: {
      fill: "#93a6b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 133",
    d: "M49.694 306.428H16.65a2.982 2.982 0 0 1-2.982-2.982 4.724 4.724 0 0 1 4.723-4.723h29.562a4.723 4.723 0 0 1 4.723 4.723 2.982 2.982 0 0 1-2.982 2.982z",
    transform: "translate(-12.333 -269.551)",
    style: {
      fill: "#7dcb60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 134",
    d: "M305.52 484.081h-5.976a1.084 1.084 0 0 1-1.083-1.081v-.832a1.084 1.084 0 0 1 1.084-1.084h5.976a1.084 1.084 0 0 1 1.084 1.084V483a1.084 1.084 0 0 1-1.085 1.081z",
    transform: "translate(-269.314 -434.101)",
    style: {
      fill: "#657488"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 135",
    d: "m145.055 80.1 1.527 2.574a1.248 1.248 0 0 0 .8.581l2.92.657a1.248 1.248 0 0 1 .663 2.042l-1.976 2.246a1.248 1.248 0 0 0-.305.94l.278 2.98a1.248 1.248 0 0 1-1.737 1.262l-2.748-1.185a1.248 1.248 0 0 0-.988 0l-2.748 1.185A1.248 1.248 0 0 1 139 92.117l.278-2.98a1.248 1.248 0 0 0-.305-.94L137 85.949a1.248 1.248 0 0 1 .663-2.042l2.92-.657a1.248 1.248 0 0 0 .8-.581l1.527-2.574a1.248 1.248 0 0 1 2.147 0z",
    transform: "translate(-123.338 -71.722)",
    style: {
      fill: "#c3e6a5"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSeatDo);
export default __webpack_public_path__ + "static/media/dashboard-seat-do.e68000d06566fcafcc18a0c86b45c2e5.svg";
export { ForwardRef as ReactComponent };